export default "__VITE_ASSET__aZfwj6Nb__"